import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { Home } from "src/views/home";
import { Navbar } from "src/views/navbar";
import { Staff } from "src/views/staff";
import { IdolSelect } from "src/views/idolSelect";
import { Footer } from "src/views/footer";
import { IdolPage } from "src/views/idol";
import useGlobalEventHandlers from "src/scripts/global";
import { SiteModel } from "src/model/model";
import { getArticleCount, SchemaType } from "src/modules/sanityApi";
import { Timeline } from "src/views/timeline";
import { Music } from "src/views/music";
import { Flags } from "./views/flags";
import { Credits } from "./views/credits";
import { useEffect, useState } from "react";
import "src/styles/loadingPage.css";
import { idolData } from "public/data/idols/idols";

export function Root({session}: {session: SiteModel}) {
	useGlobalEventHandlers();
	// getArticleCount(SchemaType.Article) // would this cause the loading to get locked up?
	// .then(data => session.setTotalAvailableArticles(data))
	const [isLoading, setLoading] = useState(false);
	useEffect(() => {
		const removeLoader = () => setLoading(false);
		// window.addEventListener("load", removeLoader);
		// return window.addEventListener("load", removeLoader);
	}, []);

	function LoadingPage(){
		return (<div className="page-loading-wrapper" style={{width: "100%",
			height: "100vh",
			overflowY: "hidden"}}>
			<style dangerouslySetInnerHTML={{__html: 
			`@keyframes pulsing {
			0% {
				--sphere-radius: 8px;
			}
			50% {
				--sphere-radius: 4px;
			}
			}
			
			@keyframes expand-spinner {
				0% {
					--spinner-radius: 8px;
				}
				100% {
					--spinner-radius: 32px;
				}
			}

			@property --spinner-radius {
				syntax: "<length>";
				inherits: true;
				initial-value: 8px;
			}

			@property --sphere-radius {
				syntax: "<length>";
				inherits: true;
				initial-value: 8px;
			}
			`}}>

			</style>
			<div className="page-loading-spinner" style={{animation: "expand-spinner 0.5s 0.5s forwards"}}>
				{idolData.order_loading.map((idol, index) => {
					return <div 
					className="page-loading-sphere"
					key={idol}
					style={{
						"--color-main":`var(--${idol}_strong)`, 
						"--color-soft":`var(--${idol}_soft)`,
						aspectRatio: 1,
						width: "20px",
						backgroundImage: "radial-gradient(circle at center,var(--color-main) var(--sphere-radius),#0000 0 )",
						position: "absolute",
						left: "50%",
						top: "50%",
						animation: "pulsing 1s infinite",
						transform: `translate(calc(var(--spinner-radius) * cos((${index} + 1) * 2 * pi / 9 + 8 * pi / 9 - pi / 2)),calc(var(--spinner-radius) * sin((${index} + 1) * 2 * pi / 9 + 8 * pi / 9 - pi / 2)))`,
						animationDelay: `calc(${index} * 100ms)`,
						// filter: `drop-shadow(0px 0px 1px var(--color-main))`
					}}
					/>
				})}

			</div>
		
		</div>)
	}

	return <>
		{isLoading ? <LoadingPage/> :
		<>
		<Navbar/>
		
		<Routes>
			<Route path="/" element={<Home session={session}/>} />
			<Route path="/staff" element={<Staff />} />
			<Route path="/idols" element={<IdolSelect/>} />
			<Route path="/idols/:slug" element={<IdolPage/>} />
			{/* <Route path="/news" element={<News session={session}/>}/>
			<Route path="/news/:slug" element={<NewsArticle session={session}/>}/> */}
			<Route path="/timeline" element={<Timeline session={session}/>}/>
			<Route path="/music" element={<Music session={session}/>}/>
			<Route path="/flags" element={<Flags/>} />
			<Route path="/credits" element={<Credits session={session}/>} />
			
			{/*<Route path="*" element={
				<Error code={404} title={"Not Found"} body={<Error404Body/>}/>
			}/> */}
		</Routes>
		<div className="sky-wrapper">
			<video autoPlay={true} muted={true} loop={true} disabled={true} id="animated-sky" aria-hidden={true}>
				<source src="/images/bg/sky_animated_3.webm" type="video/webm"/>
			</video>
		</div>
		<Footer/>
		</>
		}
	</>;
}
